import { createMuiTheme, createStyles } from "@material-ui/core/styles";

import { brandColors, statusColors } from "./brandgenColorPalette";

const theme = createMuiTheme({
  typography: {
    fontFamily: "Gilroy, sans-serif",
  },
  palette: {
    primary: {
      contrastText: brandColors.tertiary,
      dark: brandColors.primary,
      light: brandColors.accent,
      main: brandColors.secondary,
    },
    secondary: {
      contrastText: "#fff",
      dark: "#D9D9D9",
      light: "#D9D9D9",
      main: "#D9D9D9",
    },
    // eslint-disable-next-line sort-keys
    error: {
      main: statusColors.error,
    },
    success: {
      main: statusColors.success,
    },
  },
  shape: {
    borderRadius: 5,
  },
  /**
   * The overrides section is expected to be the last key in the object.
   */
  // eslint-disable-next-line sort-keys
  overrides: {
    MuiCssBaseline: {
      "@global": {
        "*::-webkit-scrollbar": {
          height: "0.7em",
          width: "0.4em",
        },
        "*::-webkit-scrollbar-thumb": {
          backgroundColor: brandColors.secondary,
          borderRadius: "5px",
        },
      },
    },
    MuiListItem: createStyles({
      root: {
        "&&:hover": {
          backgroundColor: "#0083EF",
          color: "white",
        },
      },
    }),
    MuiListSubheader: createStyles({
      root: {
        fontSize: "1.2rem",
      },
    }),
    MuiTypography: createStyles({
      body1: {
        fontSize: ".92rem",
      },
    }),
  },
});

export default theme;
